import Sidebar from '@/components/layout/Sidebar'
import { useStore } from '@/store'

// Animated sidebar container. Two nested divs because the outer one drives the
// width transition (which keeps the layout grid honest) and the inner one
// drives the slide/fade effect on the contents.
export default function SidebarReveal() {
  const sidebarOpen = useStore(s => s.sidebarOpen)
  return (
    <div
      style={{
        width: sidebarOpen ? 'var(--sidebar-w)' : 0,
        overflow: 'hidden',
        transition: 'width 220ms cubic-bezier(0.19, 1, 0.22, 1)',
        willChange: 'width',
      }}
    >
      <div
        style={{
          width: 'var(--sidebar-w)',
          height: '100%',
          transform: sidebarOpen ? 'translateX(0)' : 'translateX(-10px)',
          opacity: sidebarOpen ? 1 : 0,
          transition: 'transform 220ms cubic-bezier(0.19, 1, 0.22, 1), opacity 180ms ease',
        }}
      >
        <Sidebar />
      </div>
    </div>
  )
}